
<div id="IPTV_Editor" #IPTVEditor>

  <div class="groups" >
      <header (dragover)="group_dragover($event)" (dragenter)="group_dragenter(-1, $event)" class="bg-blue blueBGR">Группы</header>
      <div #groupsBlock>
        <ng-template ngFor let-group [ngForOf]="groups" let-i="index">
          <span [tabindex]="10" 
            [ngClass]="{'bg-gray': group.id == group_selected.id, move: group.move, moved: group.moved, 
            removed: group.id === null, over: i === group_over, deleted: group.deleted, added: group.added, 
            ch_in_group: group_selected.id === -1 && IPTVEditor.chINgroupID === group.id}" 
            [attr.draggable]="group.id === null ? 'false' : 'true' " class="bg-orange orangeBGR"
          (click)="group_select(group)"
          (keyup.enter)="group_select(group)"
          (dblclick)="group_rename(group)"
          (dragstart)="group_dragstart(group, $event)"
          (drop)="group_drop(group)"
          (dragend) = "group_dragend()"
          (dragenter)="group_dragenter(i, $event)"
          (dragover)="group_dragover($event)"
          > {{group.name}}
            <b *ngIf="group.id != null" (click)="group_remove_event(group); $event.stopPropagation();" class="remove" title="Удалить группу">&#xf252;</b>
            <i class="Trash" *ngIf="group.id == null" (click)="empty_trash_event($event)" title="Очистка корзины">&#xf252;</i>
          </span>
        </ng-template>
      </div>
      <p tabindex="10" class="add bg-blue blueBGR" (click)="group_add($event)" (keydown.enter)="group_add($event)" title="Добавить группу"><b>+</b></p>
      
  </div>

  <div class="channels">
      <header (dragover)="group_dragover($event)" (dragenter)="channel_dragenter({url: '-1', name: 'First', group_id: null, tvg_id: null, icon: null}, null)" class="bg-blue blueBGR"
      ><b class="shift_key ion" (click)="shiftKey = !shiftKey; ctrlKey = shiftKey && ctrlKey ? false : ctrlKey;" [ngClass]="{active: shiftKey}" title="Выделяет диапазон каналов, между текущим и ранее выбранным.">Shift</b>
      
      <form  class="channels_search" action="">
        <input [formControl]="channelsSearh" *ngIf="showChannelsSearchInput"  (keyup.enter)="channels_filter({search: $event.target.value})" 
          (blur)="epgChannels.emit(channelsFiltered);"
          [autofocus] type="search" name="channels_search_input" placeholder="Имя канала" size="1" class="input-gray">
        <span *ngIf="!showChannelsSearchInput" (click)="showChannelsSearchInput = true;" class="channels_search_button" title="Поиск канала" tabindex="10">Каналы</span>
      </form>

      <b class="ctrl_key ion" (click)="ctrlKey = !ctrlKey; shiftKey = shiftKey && ctrlKey ? false : shiftKey;"[ngClass]="{active: ctrlKey}" title="При каждом клике на канал, выделяет его для перемещения">Ctrl</b></header>
      <ul #channelsBlock>
    <ng-template ngFor let-channel [ngForOf]="channels | filterChannels : channelsFiltered" let-i="index">
        <li [tabIndex]="10" draggable="true" [ngClass]="{move: channel.move, moved: channel.moved, deleted: channel.deleted, added: channel.added}"
        (dragstart)="channel_dragstart(channel, $event)"
        (dragenter)="channel_dragenter(channel, $event)"
        (dragover)="group_dragover($event)"
        (dragend)="channel_dragend($event)"
        (drop)="channel_drop($event)"
        (dblclick)="channel_rename(channel)"
        (click)="click_grouping($event, channel)"
        (keyup.enter)="channel_play(channel)"
        (mouseover)="group_selected.id == -1 ? IPTVEditor.chINgroupID = channel.group_id : null"
        (mouseleave)="IPTVEditor.chINgroupID > -1 ? IPTVEditor.chINgroupID = -1 : null"
        (focus)="channel_focus($event.target)"
        (blur)="channel_blur($event.target)"
        ><a target="_blank" href="#" class="play" (click)="$event.stopPropagation(); channel_play(channel);" title="Play" tabindex="-1">
          <b class="ion"></b>
          <img src="{{channel.icon.search('http') === 0 ? channel.icon : (channel.icon  ? '/img/tvicons/'+channel.icon : '/img/tvicons/icon')}}" width="auto" height="30" 
          (error)="$event.target.src = '/img/tvicons/error'"/></a>
        <div>
          <span>{{channel.name}}</span>
          <i *ngIf="channel.epg" (contextmenu)="$event.preventDefault(); epg_day(channel)" class="epg">{{channel.epg[0]?.programm}}</i>
        </div>
        <div *ngIf="channel.epg" class="epg_progress" [ngStyle]="{width: (channel.epg[0]?.progress)+'%'}"></div>
        <b (click)="$event.stopPropagation(); channel_remove(channel)" class="remove" title="Отправить в корзину">&#xf252;</b>
      </li>
    </ng-template>
      </ul>
      <p tabindex="10" class="add bg-blue blueBGR" (click)="channel_add($event)" (keydown.enter)="channel_add($event)" title="Добавить канал"><b>+</b></p>
  </div>

</div>